module.exports = __webpack_public_path__ + "static/media/paints_agsar.d61a4c00.jpg";